import { CustomerPricingRules } from "@megaron/docs-contracts";

type Props = {
  pricingRules: CustomerPricingRules;
};

export const PricingListCell: React.FC<Props> = ({ pricingRules }) => pricingRules?.priceList ?? "-";
